module.exports = __webpack_public_path__ + "static/media/playstore.d99a622c.svg";